/**
 * Frontend Feature Flags Helper
 *
 * Reads feature flags injected into window.__DASHBAL_CONFIG__.
 * All flagged features default to false (opt-in only).
 */

export function isForecastingEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  return window.__DASHBAL_CONFIG__?.enableForecasting === true;
}

export function isTrafficAttributionEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  return window.__DASHBAL_CONFIG__?.enableTrafficAttribution === true;
}

export function isTemplateEnabled(template: { id?: string; name?: string }): boolean {
  const name = (template.name || '').toLowerCase();
  const id = (template.id || '').toLowerCase();
  if (!isForecastingEnabled()) {
    if (id.includes('forecasting_crystal_ball') || name.includes('crystal ball') || name.includes('forecasting')) {
      return false;
    }
  }
  if (!isTrafficAttributionEnabled()) {
    if (id.includes('traffic_attribution') || /traffic\s*(&|and)?\s*attribution/.test(name)) {
      return false;
    }
  }
  return true;
}
